import { render, staticRenderFns } from "./FacePhoto.vue?vue&type=template&id=507ee441&scoped=true&"
import script from "./FacePhoto.vue?vue&type=script&lang=js&"
export * from "./FacePhoto.vue?vue&type=script&lang=js&"
import style0 from "./FacePhoto.vue?vue&type=style&index=0&id=507ee441&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ee441",
  null
  
)

export default component.exports